import { Alert } from 'flowbite-react';

const EsiaErrors = () => {
  return (
    <div className="flex flex-col gap-4">
      <Alert color="failure">
        <div className="flex flex-col gap-2">
          <h3 className="font-semibold">Ошибка ЕСИА</h3>
          <p className="text-sm">
            Произошла ошибка при авторизации через ЕСИА. Проверьте корректность
            данных или попробуйте другой способ входа.
          </p>
        </div>
      </Alert>
    </div>
  );
};

export { EsiaErrors };
